import React, { memo } from 'react';
import { shape, string } from 'prop-types';
import styled from 'styled-components';
import useScript from './useScript';
var LANDSCAPE_RATIO = '56.25%';
/**
 * Apply provider-specific styles.
 */

var OEmbed = /*#__PURE__*/styled.div.withConfig({
  displayName: "OEmbed",
  componentId: "sc-19fj6th-0"
})(["", " display:flex;justify-content:center;"], function (_ref) {
  var styles = _ref.styles;
  return styles;
});
/**
 * The following object declares a list of supported Canonical providers
 * and their attributes. Not all providers have the same attributes.
 */

export var providers = {
  instagram: {
    script: 'https://www.instagram.com/embed.js',
    styles: "\n      .instagram-media {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n        min-width: auto !important;\n      }\n    "
  },
  twitter: {
    script: 'https://platform.twitter.com/widgets.js',
    styles: "\n      .twitter-tweet {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important;\n      }\n    "
  },
  youtube: {
    styles: "\n      padding-top: ".concat(LANDSCAPE_RATIO, ";\n      position: relative;\n      overflow: hidden;\n\n      > iframe {\n        border: none;\n        height: 100%;\n        left: 0;\n        position: absolute;\n        top: 0;\n        width: 100%;\n      }\n    ")
  }
};

var CanonicalEmbed = function CanonicalEmbed(_ref2) {
  var provider = _ref2.provider,
      oEmbed = _ref2.oEmbed;
  useScript(providers[provider].script);
  return /*#__PURE__*/React.createElement(OEmbed, {
    styles: providers[provider].styles,
    dangerouslySetInnerHTML: {
      __html: oEmbed.html
    }
  });
};

CanonicalEmbed.propTypes = {
  provider: string.isRequired,
  oEmbed: shape({
    html: string.isRequired
  }).isRequired
};
export default /*#__PURE__*/memo(CanonicalEmbed);